import { render, staticRenderFns } from "./Son_CheckBox.vue?vue&type=template&id=b8ab0ad8&scoped=true&"
import script from "./Son_CheckBox.vue?vue&type=script&lang=js&"
export * from "./Son_CheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ab0ad8",
  null
  
)

export default component.exports